
class EditForm {
  constructor(form) {
    this.form = form;
    this.name = form.dataset.editForm;

    this.buttonEdit = form.querySelector('[data-button-edit]');
    this.buttonCancel = form.querySelector('[data-button-cancel]');
    this.buttonSave = form.querySelector('[data-button-save]');

    this.inputs = form.querySelectorAll('input[type="text"],input[type="tel"]');

    this.initialValues = {};

   this.init();
  }

  init() {
    if (this.buttonEdit) {
      this.disableInputs();
    }
    this.initInitialValues();

    this.bind();
  }

  bind() {
    this.bindButtons();
  }

  bindForm() {
    const instance = this;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      instance.request();
    });
  }

  bindButtons() {
    const instance = this;
    if (this.buttonEdit) {
      this.buttonEdit.addEventListener('click', (e) => {
        e.preventDefault();
        instance.setEdit();
      });
    }

    if (this.buttonCancel) {
      this.buttonCancel.addEventListener('click', (e) => {
        e.preventDefault();
        instance.resetInputs();
        instance.unsetEdit();
      });
    }

    if (this.buttonSave) {
      this.buttonSave.addEventListener('click', (e) => {
        e.preventDefault();
        instance.request();
      });
    }
  }

  request() {
    const instance = this;

    const jax = new Jax(
      this.form.getAttribute('action'),
      this.form.getAttribute('method'),
      true
    );

    jax.send(new FormData(this.form))
      .then((json) => {
        if (json.success) {
          validatorCleanErrors(this.form, this.name);
          instance.initInitialValues();
          instance.unsetEdit();
          instance.setSuccess();
        } else if (json.errors) {
          validatorValidateForm(this.form, this.name, json.errors);
        }
      });

  }

  setEdit() {
    this.form.classList.add('_on-edit');
    this.enabledInputs();
  }

  unsetEdit() {
    this.form.classList.remove('_on-edit');
    this.disableInputs();
  }

  enabledInputs() {
    this.inputs.forEach((input) => {
      input.disabled = '';
    });
  }

  disableInputs() {
    this.inputs.forEach((input) => {
      input.disabled = true;
    });
  }

  resetInputs() {
    const instance = this;
    this.inputs.forEach((input) => {
      const name = input.name;
      input.value = instance.initialValues[name] || '';
      if (input.type === 'tel') {
        input.dispatchEvent(new Event('input'));
      }
    });
  }

  setSuccess() {
    this.form.classList.add('_success')
  }

  initInitialValues() {
    const instance = this;
    this.inputs.forEach((input) => {
      instance.initialValues[input.name] = input.value;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[data-edit-form]').forEach((form) => {
    new EditForm(form);
  });
});
